export default "__VITE_ASSET__b5b03c20__"